import React from 'react';
import PropTypes from 'prop-types';
import _trim from 'lodash/trim';
import { Field } from 'redux-form';

import ReorderMenu from 'components/ReorderMenu';
import Toggler from 'components/Toggler';
import { FormLabel, FormGroupField, FormGroupTextarea } from 'components/Form';

import './style.scss';

const RuleGroupInspectGeneral = ({
  reorderItem,
  onClose,
  order,
  orderList,
  index,
  isArchived,
  isReorderOpened,
  onFocusOrder,
  onClickOrder,
  onChangeOrder,
  normalizeOrder,
}) => (
  <div styleName="group" data-item="group">
    <div styleName="infos">
      <div styleName="order">
        {isReorderOpened && (
          <ReorderMenu
            index={index}
            orderList={orderList}
            model={{ order }}
            isOpen={isReorderOpened}
            onClose={onClose}
            reorderItem={reorderItem}
            mode="input"
          />
        )}
        <Field
          type="number"
          name="order"
          label="Order"
          placeholder="Order"
          styleName="input"
          data-test="rule-order"
          normalize={normalizeOrder}
          component={FormGroupField}
          onFocus={onFocusOrder}
          onClick={onClickOrder}
          onChange={onChangeOrder}
          disabled={isArchived}
        />
      </div>
      <div styleName="complex-input">
        <FormLabel htmlFor="name">GROUP NAME</FormLabel>
        <Field
          autoFocus
          styleName="input"
          type="text"
          normalize={_trim}
          name="name"
          autoComplete="off"
          placeholder="Please type a name for the group"
          disabled={isArchived}
          component={FormGroupField}
          data-test="name-field"
        />
      </div>
      <Field
        name="enabled"
        label="Active"
        styleName="toggler"
        isDisabled={isArchived}
        component={Toggler}
      />
    </div>
    <Field
      type="textarea"
      name="description"
      label="DESCRIPTION"
      styleName="textarea"
      placeholder="Description"
      disabled={isArchived}
      component={FormGroupTextarea}
      data-test="description-field"
    />
  </div>
);

RuleGroupInspectGeneral.propTypes = {
  isArchived: PropTypes.bool,
  isReorderOpened: PropTypes.bool,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClose: PropTypes.func,
  reorderItem: PropTypes.func,
  onFocusOrder: PropTypes.func,
  onClickOrder: PropTypes.func,
  onChangeOrder: PropTypes.func,
  normalizeOrder: PropTypes.func,
  order: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  orderList: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number,
      order: PropTypes.string,
    }),
  ),
};

export default RuleGroupInspectGeneral;
